@file:OptIn(InternalResourceApi::class)

package diana.soleil.design.iraniancanadienbazzar.core.designsystem.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String =
    "composeResources/diana.soleil.design.iraniancanadienbazzar.core.designsystem.resources/"

@delegate:ResourceContentHash(1_181_889_443)
internal val Res.drawable.brand_mark: DrawableResource by lazy {
      DrawableResource("drawable:brand_mark", setOf(
        ResourceItem(setOf(), "${MD}drawable/brand_mark.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-44_707_018)
internal val Res.drawable.cat_auto_services: DrawableResource by lazy {
      DrawableResource("drawable:cat_auto_services", setOf(
        ResourceItem(setOf(), "${MD}drawable/cat_auto_services.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(606_121_703)
internal val Res.drawable.cat_beauty_wellness: DrawableResource by lazy {
      DrawableResource("drawable:cat_beauty_wellness", setOf(
        ResourceItem(setOf(), "${MD}drawable/cat_beauty_wellness.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(172_457_063)
internal val Res.drawable.cat_community_services: DrawableResource by lazy {
      DrawableResource("drawable:cat_community_services", setOf(
        ResourceItem(setOf(), "${MD}drawable/cat_community_services.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(233_915_520)
internal val Res.drawable.cat_education_tutors: DrawableResource by lazy {
      DrawableResource("drawable:cat_education_tutors", setOf(
        ResourceItem(setOf(), "${MD}drawable/cat_education_tutors.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_735_272_244)
internal val Res.drawable.cat_events_entertainment: DrawableResource by lazy {
      DrawableResource("drawable:cat_events_entertainment", setOf(
        ResourceItem(setOf(), "${MD}drawable/cat_events_entertainment.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_035_119_590)
internal val Res.drawable.cat_finance_accounting: DrawableResource by lazy {
      DrawableResource("drawable:cat_finance_accounting", setOf(
        ResourceItem(setOf(), "${MD}drawable/cat_finance_accounting.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_101_220_837)
internal val Res.drawable.cat_food_restaurants: DrawableResource by lazy {
      DrawableResource("drawable:cat_food_restaurants", setOf(
        ResourceItem(setOf(), "${MD}drawable/cat_food_restaurants.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-344_223_636)
internal val Res.drawable.cat_grocery_specialty_food: DrawableResource by lazy {
      DrawableResource("drawable:cat_grocery_specialty_food", setOf(
        ResourceItem(setOf(), "${MD}drawable/cat_grocery_specialty_food.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_593_562_483)
internal val Res.drawable.cat_home_services: DrawableResource by lazy {
      DrawableResource("drawable:cat_home_services", setOf(
        ResourceItem(setOf(), "${MD}drawable/cat_home_services.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-391_681_734)
internal val Res.drawable.cat_legal_services: DrawableResource by lazy {
      DrawableResource("drawable:cat_legal_services", setOf(
        ResourceItem(setOf(), "${MD}drawable/cat_legal_services.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_115_957_590)
internal val Res.drawable.cat_medical_health: DrawableResource by lazy {
      DrawableResource("drawable:cat_medical_health", setOf(
        ResourceItem(setOf(), "${MD}drawable/cat_medical_health.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(274_337_544)
internal val Res.drawable.cat_moving_storage: DrawableResource by lazy {
      DrawableResource("drawable:cat_moving_storage", setOf(
        ResourceItem(setOf(), "${MD}drawable/cat_moving_storage.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-372_506_513)
internal val Res.drawable.cat_real_estate: DrawableResource by lazy {
      DrawableResource("drawable:cat_real_estate", setOf(
        ResourceItem(setOf(), "${MD}drawable/cat_real_estate.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-322_635_746)
internal val Res.drawable.cat_shopping: DrawableResource by lazy {
      DrawableResource("drawable:cat_shopping", setOf(
        ResourceItem(setOf(), "${MD}drawable/cat_shopping.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_841_424_293)
internal val Res.drawable.cat_technology_services: DrawableResource by lazy {
      DrawableResource("drawable:cat_technology_services", setOf(
        ResourceItem(setOf(), "${MD}drawable/cat_technology_services.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_430_371_109)
internal val Res.drawable.gem_danestaniha: DrawableResource by lazy {
      DrawableResource("drawable:gem_danestaniha", setOf(
        ResourceItem(setOf(), "${MD}drawable/gem_danestaniha.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-694_212_537)
internal val Res.drawable.gem_jokes: DrawableResource by lazy {
      DrawableResource("drawable:gem_jokes", setOf(
        ResourceItem(setOf(), "${MD}drawable/gem_jokes.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-551_209_982)
internal val Res.drawable.gem_poetry: DrawableResource by lazy {
      DrawableResource("drawable:gem_poetry", setOf(
        ResourceItem(setOf(), "${MD}drawable/gem_poetry.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(513_169_438)
internal val Res.drawable.gem_recipes: DrawableResource by lazy {
      DrawableResource("drawable:gem_recipes", setOf(
        ResourceItem(setOf(), "${MD}drawable/gem_recipes.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_804_471_571)
internal val Res.drawable.gem_shahnameh: DrawableResource by lazy {
      DrawableResource("drawable:gem_shahnameh", setOf(
        ResourceItem(setOf(), "${MD}drawable/gem_shahnameh.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-855_229_531)
internal val Res.drawable.gem_soon: DrawableResource by lazy {
      DrawableResource("drawable:gem_soon", setOf(
        ResourceItem(setOf(), "${MD}drawable/gem_soon.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(102_494_556)
internal val Res.drawable.gem_stories: DrawableResource by lazy {
      DrawableResource("drawable:gem_stories", setOf(
        ResourceItem(setOf(), "${MD}drawable/gem_stories.png", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("brand_mark", Res.drawable.brand_mark)
  map.put("cat_auto_services", Res.drawable.cat_auto_services)
  map.put("cat_beauty_wellness", Res.drawable.cat_beauty_wellness)
  map.put("cat_community_services", Res.drawable.cat_community_services)
  map.put("cat_education_tutors", Res.drawable.cat_education_tutors)
  map.put("cat_events_entertainment", Res.drawable.cat_events_entertainment)
  map.put("cat_finance_accounting", Res.drawable.cat_finance_accounting)
  map.put("cat_food_restaurants", Res.drawable.cat_food_restaurants)
  map.put("cat_grocery_specialty_food", Res.drawable.cat_grocery_specialty_food)
  map.put("cat_home_services", Res.drawable.cat_home_services)
  map.put("cat_legal_services", Res.drawable.cat_legal_services)
  map.put("cat_medical_health", Res.drawable.cat_medical_health)
  map.put("cat_moving_storage", Res.drawable.cat_moving_storage)
  map.put("cat_real_estate", Res.drawable.cat_real_estate)
  map.put("cat_shopping", Res.drawable.cat_shopping)
  map.put("cat_technology_services", Res.drawable.cat_technology_services)
  map.put("gem_danestaniha", Res.drawable.gem_danestaniha)
  map.put("gem_jokes", Res.drawable.gem_jokes)
  map.put("gem_poetry", Res.drawable.gem_poetry)
  map.put("gem_recipes", Res.drawable.gem_recipes)
  map.put("gem_shahnameh", Res.drawable.gem_shahnameh)
  map.put("gem_soon", Res.drawable.gem_soon)
  map.put("gem_stories", Res.drawable.gem_stories)
}
